// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert,
  Table,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "../dashboard/dashboard.scss";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import { deleteUser } from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";

import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import NumberFormat from "react-number-format";
import Cookies from "universal-cookie";
import auth from "../../../services/auth";

import languageConfig from "../../../config/languageConfig";

const cookies = new Cookies();

const history = createBrowserHistory();
let cart = "";

class DeleteUser extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);
    const userinfo = auth.getUserInfo();

    this.state = {
      email: userinfo.email,
      firstname: userinfo.firstName,
      lastname: userinfo.lastName,
      orderID: "",
      showAlert: false,
      disabled: false,
      orderList: "",
      hover: false,
      multi_lang: "no",
      lang: "",
      default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
      isLoading: false,
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ disabled: false });
  };

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    siteData.default_lang = lang;
    localStorage.setItem("siteDDBStatus", JSON.stringify(siteData));
    this.setState({
      default_lang: lang,
    });

    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang);
    this.props.getMenuList({
      page: 1,
      lang: lang,
      cityID: siteData.default_city,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({ userKey: cookies.get("token"), lang: lang });
    }
  };

  handlePageChange = (page) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({
        userKey: cookies.get("token"),
        lang:
          siteData && siteData.default_lang
            ? siteData.default_lang
            : this.state.default_lang,
      });
    }
  };

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  Clear() {
    this.setState({
      email: "",
      orderID: "",
    });
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    let disableSubscriptionPopup = localStorage.getItem(
      "disableSubscriptionPopup"
    )
      ? localStorage.getItem("disableSubscriptionPopup")
      : false;
    let accessibleCities = localStorage.getItem("accessibleCities")
      ? JSON.parse(localStorage.getItem("accessibleCities"))
      : [];

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    if (siteData) {
      this.setState({ fontFamilies: siteData.font_families });
    }

    if (siteData) {
      this.setState({
        twitterPage: siteData.twitterPage,
        facebookPage: siteData.facebookPage,
        siteName: siteData.siteName,
        youtube_link: siteData.youtube_link,
        insta_link: siteData.insta_link,
      });
      let showCityPasswordFrom = true;
      if (
        siteData.password_protect == "active" &&
        this.props.match.path != "/login" &&
        this.props.match.path != "/register/"
      ) {
        const cityPasswordIndx = siteData.city_passwords.findIndex(
          (x) => x.cityID === siteData.default_city
        );
        const cityIndx = accessibleCities.findIndex(
          (x) => x.cityID === siteData.default_city
        );

        if (
          (cityIndx >= 0 && accessibleCities[cityIndx].status == true) ||
          cityPasswordIndx == -1
        ) {
          showCityPasswordFrom = false;
        }
        this.setState({ showCityPasswordFrom: showCityPasswordFrom });
      }
    }

    if (this.props.themeData) {
      this.setState({
        themeData: this.props.themeData,
      });

      if (this.props.themeData.menu_bar) {
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color,
          },
        });
      } else {
        this.setState({
          menuBgStyles: {
            backgroundColor: "",
          },
        });
      }
      if (this.props.themeData.footer) {
        this.setState({
          footerBgStyles: {
            backgroundColor: this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            color: this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            color: this.props.themeData.footer.footer_social_link_color,
          },
        });
      } else {
        this.setState({
          footerBgStyles: {
            backgroundColor: "",
          },
          footerTextStyles: {
            color: "",
          },
          footer_social_link_color: {
            color: "",
          },
        });
      }

      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      } else {
        this.setState({
          button_color: "",
          mouseover_color: "",
        });
      }
    }
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
    }

    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.language) {
      if (this.state.default_lang !== nextProps.language) {
        this.setState({ default_lang: nextProps.language });
      }
    }

    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    if (this.props.ordertracking != nextProps.ordertracking) {
      if (nextProps.ordertracking) {
        this.setState({
          showAlert: true,
          alertMessage:
            "The request to delete your CincySavers account has been received. An admin will confirm account deletion via the email you provided on this form within 10 business days.",
          msgType: "success",
        });

        this.setState({ disabled: false });
        this.setState({ isLoading: false });
      }
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        this.setState({ showAlert: true });
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.message !== nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
      //Clear();
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  handleSubmit = (e) => {
    e.preventDefault();
    // const err = this.validate();
    var x = window.confirm("Are you sure to delete this account?");
    if (x === true) {
      this.setState({ disabled: true });
      this.setState({ isLoading: true });
      let formData = {
        email: this.state.email,
        orderID: this.state.orderID,
        lang: this.state.default_lang,
      };
      this.props.deleteUser(formData);
    }
  };

  render() {
    return (
      <div>
        {this.state.isLoading == true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form onSubmit={this.handleSubmit}>
          <div className="container">
            <Col md={12}>
              <div className="panel margin-top">
                <header className="panel-heading text-default">
                  Managing your CincySavers account
                </header>
                <div className="panel-body">
                  {this.state.showAlert && this.state.alertMessage !== "" && (
                    <div className="col-lg-12">
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>{this.state.msgType}:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
                  <div>
                    <h4>
                      <strong>Delete your account</strong>
                    </h4>
                    <p>
                      You can request to{" "}
                      <strong>delete your CincySavers account</strong> at any
                      time using the form below. Your data will be permanently
                      removed from our database. Any previously purchased
                      vouchers will be automatically forfeited and will be void
                      and unusable. If you have a previously printed voucher,{" "}
                      <strong>
                        that voucher will be void upon an admin deleting the
                        Account
                      </strong>{" "}
                      and will not be usable or subject to any refund or credit
                      (unless it falls within 30 days from the original
                      purchase, in such cases a refund may be awarded{" "}
                      <strong>prior</strong> to deletion. Contact
                      deals@cincysavers.com with refund requests.)
                    </p>
                    <h4>
                      <strong>Deactivate your account</strong>
                    </h4>
                    <p>
                      Alternatively, you may choose to{" "}
                      <strong>deactivate your CincySavers account</strong> (i.e.
                      pause your account) by contacting our Customer Service
                      department at{" "}
                      <a href="mailto:deals@cincysavers.com">
                        deals@cincysavers.com
                      </a>
                      . Your information will be retained in our database and
                      could be reactivated, if you choose, by contacting{" "}
                      <a href="mailto:deals@cincysavers.com">
                        deals@cincysavers.com
                      </a>
                      . Upon deactivation, you will not be able to log in, and
                      your previously purchased vouchers will be automatically
                      forfeited and will be void and unusable. Deactivating does{" "}
                      <strong>NOT</strong> delete the account.
                    </p>
                    <h4>
                      <strong>Delete the app</strong>
                    </h4>
                    <p>
                      You might also want to simply delete the CincySavers
                      mobile app but keep your CincySavers account intact for
                      website usage and voucher redemption. To uninstall an
                      iPhone app, follow{" "}
                      <a href="https://support.apple.com/en-us/HT207618">
                        these instructions
                      </a>
                      . For Android,{" "}
                      <a href="https://support.google.com/android/answer/2521768?hl=en">
                        click here
                      </a>
                      . The mobile app can be reinstalled by going to the App
                      Store or Google Play. Your login would remain the same.
                    </p>
                    <h4>
                      <strong>Request to delete account</strong>
                    </h4>
                    <p>
                      If you are sure you want to delete your account, fill out
                      the form below. Upon submitting a request, your personal
                      information and transaction history will be removed from
                      the database by an admin within 10 business days. In
                      addition, you will be opted out of all CincySavers
                      marketing emails. You will need to delete the CincySavers
                      mobile app yourself following the instructions above.{" "}
                      <strong>Deleting your account is irrevocable.</strong>
                    </p>
                    <p>
                      <strong>{this.state.email}</strong>
                    </p>
                  </div>

                  {/* <Row>
                    <p className="text-center">
                      {
                        languageConfig[this.state.default_lang]
                          .user_account_detail
                      }
                    </p>
                    <Col md={12} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          {languageConfig[this.state.default_lang].first_name}
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.firstname}
                          placeholder={
                            languageConfig[this.state.default_lang].first_name
                          }
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.emailError }}
                          name="email"
                          autoComplete="off"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          {languageConfig[this.state.default_lang].last_name}:
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.lastname}
                          placeholder={
                            languageConfig[this.state.default_lang].last_name
                          }
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.orderIDError }}
                          name="orderID"
                          autoComplete="off"
                        />
                      </FormGroup>
                    </Col>
                  </Row> */}
                  <Row>
                    <Col md={12} xs={12}>
                      <Button
                        bsStyle="success"
                        style={{
                          backgroundColor:
                            this.state.hover && this.state.hoverID == "order"
                              ? this.state.mouseover_color
                              : this.state.button_color
                              ? this.state.button_color
                              : "#77C84E",
                        }}
                        data-id={"order"}
                        onMouseEnter={this.hoverOn}
                        onMouseLeave={this.hoverOff}
                        type="submit"
                        disabled={this.state.disabled}
                      >
                        {
                          languageConfig[this.state.default_lang]
                            .delete_user_button
                        }
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </div>
        </form>
      </div>
    );
  }
}

DeleteUser.propTypes = {
  deleteUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: state.frontReducer.error,
  ordertracking: state.frontReducer.ordertracking,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
});

export default compose(
  connect(mapStateToProps, { deleteUser, renderAlert, clearAlert })
)(DeleteUser);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/DeleteUser.js